import notify from 'devextreme/ui/notify';
import {Injectable} from "@angular/core";

@Injectable()
export class NotificationService {

  notifyError(message: string) {
    notify(message, 'error', 6000)
  }

}



// WEBPACK FOOTER //
// ./src/app/distributor/services/notification-service.ts